import React from 'react';
import { BusinessCardArtwork } from './business-card/BusinessCardArtwork';
/**
 * Dentico Business Card — Russian (Dentico_Business_Card_RU)
 * Independent document duplicated from the approved English master. Only the
 * front-side subtitle differs; logo, contacts, QR (WHATSAPP US → WhatsApp chat),
 * address and all layout/print settings are identical.
 */
export function BusinessCardNewRuPage() {
  return <BusinessCardArtwork docName="Dentico Business Card — Russian" subtitle={['Русскоязычная стоматологическая', 'клиника в Лондоне']} data-id="element-1183" />;
}